"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TotalCell = exports.Cell = void 0;
var _grid = require("./grid.tokens");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var Cell = exports.Cell = _styledComponents.default.div.withConfig({
  displayName: "Cellstyled__Cell",
  componentId: "sc-w3vqjy-0"
})(["height:100%;width:100%;padding:", ";background-color:", ";", " ", ""], function (_ref) {
  var padding = _ref.padding;
  return _grid.gridTokens.padding[padding || _grid.Padding.default];
}, function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return _grid.gridTokens.background.color[backgroundColor || _grid.BackgroundColor.default];
}, function (_ref3) {
  var hoverable = _ref3.hoverable,
    locked = _ref3.locked;
  return hoverable !== false && (0, _styledComponents.css)(["&:hover{background-color:", ";}"], locked ? _grid.gridTokens.cell.hover.locked : _grid.gridTokens.cell.hover.default);
}, function (_ref4) {
  var selected = _ref4.selected;
  return (0, _styledComponents.css)(["", ""], selected && "\n\t\t        outline-style: solid;\n            outline-width: ".concat(_grid.gridTokens.border.width.default, ";\n            outline-color: ").concat(_grid.gridTokens.border.color.hover, ";\n\t\t"));
});
var weekBorder = (0, _styledComponents.css)(["position:relative;&:after{content:'';position:absolute;top:-1px;right:-1px;bottom:-1px;left:-1px;border-top:solid 1px ", ";border-bottom:solid 1px ", ";}&:last-of-type{&:after{border-right:solid 1px ", ";}}&:first-of-type{&:after{border-left:solid 1px ", ";}}"], _grid.gridTokens.border.color.hover, _grid.gridTokens.border.color.hover, _grid.gridTokens.border.color.hover, _grid.gridTokens.border.color.hover);
var TotalCell = exports.TotalCell = (0, _styledComponents.default)(Cell).withConfig({
  displayName: "Cellstyled__TotalCell",
  componentId: "sc-w3vqjy-1"
})(["", " ", ""], function (_ref5) {
  var selected = _ref5.selected;
  return selected && (0, _styledComponents.css)(["~ div{", "}"], weekBorder);
}, function (_ref6) {
  var hoverable = _ref6.hoverable;
  return hoverable !== false && (0, _styledComponents.css)(["&:hover ~ div{", "}"], weekBorder);
});